import {
  getListOfAgent,
  getListOfEmployee,
  getListofAgentHistory,
  getListOfResignation,
  getEmployeeData,
  getTrainerList as getTrainerListApi,
  getListOfEmployeeInDocument,
  getListOfEmpInDocument,
  getListOfEmpInEmpMod,
} from 'services/axios/emp'
import { getMasterGlobalTypeList, getNestedGlobalType } from 'services/axios/config'

export const actions = {
  TOGGLE_SWITCH: 'TOGGLE_SWITCH',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  GET_EMP_LIST: 'GET_EMP_LIST',
  GET_AGENT_LIST: 'GET_AGENT_LIST',
  GET_AGENT_HISTORY: 'GET_AGENT_HISTORY',
  RESET_AGENT_HISTORY: 'RESET_AGENT',
  GET_TRAINER_LIST: 'GET_TRAINER_LIST',
  TOGGLE_LOADING: 'TOGGLE_LOADING',
  HANDLE_DOC_TYPE: 'HANDLE_DOC_TYPE',
  HANDLE_EMP_DESIGNATION: 'EMP_DESIGNATION',
  HANDLE_USER_ROLE: 'USER_ROLE',
  HANDLE_USER_PROCESS: 'HANDLE_USER_PROCESS',
  GET_DEPARTMENT: 'GET_DEPARTMENT',
  GET_USER_INFO: 'GET_USER_INFO',
  GET_RESIGNATION_LIST: 'GET_RESIGNATION_LIST',
  HANDLE_SEARCH: 'HANDLE_SEARCH',
  GET_AGENT_STATUS: 'GET_AGENT_STATUS',
  HANDLE_CAN_DOC_TYPE: 'HANDLE_CAN_DOC_TYPE',
  HANDLE_GENDER_OPTIONS: 'HANDLE_GENDER_OPTIONS',
  HANDLE_QUALIFICATION_OPTIONS: 'HANDLE_QUALIFICATION_OPTIONS',
  HANDLE_BLOOD_GROUP_OPTIONS: 'HANDLE_BLOOD_GROUP_OPTIONS',
  HANDLE_REG_STATUS: 'HANDLE_REG_STATUS',
  FETCH_TRAINING_FOR: 'FETCH_TRAINING_FOR',
  FETCH_EMPLOYEE_DATA: 'FETCH_EMPLOYEE_DATA',
  GET_EMP_LIST_IN_DOCUMENT: 'GET_EMP_LIST_IN_DOCUMENT',
  GET_EMP_LIST_IN_DOCS: 'GET_EMP_LIST_IN_DOCS',
  GET_EMP_LIST_IN_EMP: 'GET_EMP_LIST_IN_EMP',
}

export const toggle = (onChange) => {
  return {
    type: 'TOGGLE_SWITCH',
    payload: onChange,
  }
}
export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}
export const toggleLoading = (value) => {
  return {
    type: 'TOGGLE_LOADING',
    payload: value,
  }
}
export const handleEmpList = (empList) => {
  return {
    type: 'GET_EMP_LIST',
    payload: empList,
  }
}
export const handleAgentStatus = (status) => {
  return {
    type: 'GET_AGENT_STATUS',
    payload: status,
  }
}
export const handleRegStatus = (status) => {
  return {
    type: 'HANDLE_REG_STATUS',
    payload: status,
  }
}
export const handleSearch = (emp) => {
  return {
    type: actions.HANDLE_SEARCH,
    payload: emp,
  }
}
export const getEmployeeList = ({
  skip,
  limit,
  userRole = null,
  locationId = null,
  searchDepartment,
  searchProcess,
  userId,
  isActive,
  excludeAdmin,
  sortBy,
  sortOrder,
}) => {
  return async (dispatch) => {
    dispatch(toggleLoading(true))
    const response = await getListOfEmployee({
      skip,
      limit,
      userRole,
      locationId,
      searchDepartment,
      searchProcess,
      userId,
      isActive,
      excludeAdmin,
      sortBy,
      sortOrder,
    })
    dispatch({ type: actions.GET_EMP_LIST, payload: response?.data?.data })
    dispatch(toggleLoading(false))
  }
}
export const getAgentList = ({ status, skip, limit, employeeName }) => {
  return async (dispatch) => {
    dispatch(toggleLoading(true))
    const response = await getListOfAgent({ status, skip, limit, employeeName })
    dispatch({ type: actions.GET_AGENT_LIST, payload: response?.data?.data })
    dispatch(toggleLoading(false))
  }
}
export const getAllResignations = ({ skip, limit, searchedEmp, status }) => {
  return async (dispatch) => {
    dispatch(toggleLoading(true))
    const response = await getListOfResignation({ skip, limit, searchedEmp, status })
    dispatch({ type: actions.GET_RESIGNATION_LIST, payload: response?.data?.data })
    dispatch(toggleLoading(false))
  }
}
export const getAgentHistory = ({ skip, limit, userId, status }) => {
  return async (dispatch) => {
    const response = await getListofAgentHistory({ skip, limit, userId, status })
    dispatch({ type: actions.GET_AGENT_HISTORY, payload: response?.data?.data })
  }
}

export const resetAgent = () => {
  return async (dispatch) => {
    dispatch({ type: actions.RESET_AGENT_HISTORY })
  }
}

export const getEmpDesignation = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('designation')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const designation = response?.data?.data
      dispatch({
        type: actions.HANDLE_EMP_DESIGNATION,
        payload: designation,
      })
    }
  }
}
export const getDocumentType = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('document_type')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const docType = response?.data?.data
      dispatch({
        type: actions.HANDLE_DOC_TYPE,
        payload: docType,
      })
    }
  }
}
export const getCanDocumentType = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('candidate_document_type')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const docType = response?.data?.data
      dispatch({
        type: actions.HANDLE_CAN_DOC_TYPE,
        payload: docType,
      })
    }
  }
}

export const getGenderOptions = () => {
  return async (dispatch) => {
    let response = await getMasterGlobalTypeList('employee_gender')

    if (!(response?.status === 200 && response?.data?.data?.length > 0)) {
      response = await getMasterGlobalTypeList('gender')
    }

    if (response?.status === 200 && response?.data?.data?.length > 0) {
      dispatch({
        type: actions.HANDLE_GENDER_OPTIONS,
        payload: response?.data?.data,
      })
    }
  }
}

export const getQualificationOptions = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('qualification')

    if (response?.status === 200 && response?.data?.data?.length > 0) {
      dispatch({
        type: actions.HANDLE_QUALIFICATION_OPTIONS,
        payload: response?.data?.data,
      })
    }
  }
}

export const getBloodGroupOptions = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('blood_group')

    if (response?.status === 200 && response?.data?.data?.length > 0) {
      dispatch({
        type: actions.HANDLE_BLOOD_GROUP_OPTIONS,
        payload: response?.data?.data,
      })
    }
  }
}

// Action creator

export const fetchTrainingForData = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('training_type')
    dispatch({ type: actions.FETCH_TRAINING_FOR, payload: response?.data?.data })
  }
}

export const getEmpRole = (depId) => {
  return async (dispatch) => {
    const response = await getNestedGlobalType(depId, 'user_role')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const role = response?.data?.data
      dispatch({
        type: actions.HANDLE_USER_ROLE,
        payload: role,
      })
    }
  }
}
export const getEmpProcess = (depId) => {
  return async (dispatch) => {
    const response = await getNestedGlobalType(depId, 'process')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const process = response?.data?.data
      dispatch({
        type: actions.HANDLE_USER_PROCESS,
        payload: process,
      })
    }
  }
}
export const getDep = () => {
  return async (dispatch) => {
    const response = await getMasterGlobalTypeList('department')
    if (response?.status === 200 && response?.data?.data?.length > 0) {
      const department = response?.data?.data
      dispatch({
        type: actions.GET_DEPARTMENT,
        payload: department,
      })
    }
  }
}

// fetch employee details
export const getEmployeeDetail = (userId) => {
  return async (dispatch) => {
    const response = await getEmployeeData(userId)
    if (response?.status === 200) {
      const data = response?.data?.data
      dispatch({
        type: actions.FETCH_EMPLOYEE_DATA,
        payload: data,
      })
    }
  }
}

export const getTrainerList = ({ locationId }) => {
  return async (dispatch) => {
    try {
      const response = await getTrainerListApi(locationId)
      if (response?.status === 200) {
        dispatch({
          type: actions.GET_TRAINER_LIST,
          payload: response?.data?.data, // <-- trainers array
        })
      }
    } catch (error) {
      console.error('Error fetching trainer list:', error)
    }
  }
}
export const getEmployeeListInDocument = ({
  skip,
  limit,
  searchEmployee,
  locationId,
  searchDepartment,
  searchProcess,
  status,
}) => {
  return async (dispatch) => {
    const response = await getListOfEmployeeInDocument({
      skip,
      limit,
      searchEmployee,
      locationId,
      searchDepartment,
      searchProcess,
      status,
    })
    dispatch({ type: actions.GET_EMP_LIST_IN_DOCUMENT, payload: response?.data?.data })
  }
}
export const getEmpListInDocument = ({ locationId, searchDepartment, searchProcess, status }) => {
  return async (dispatch) => {
    const response = await getListOfEmpInDocument({
      locationId,
      searchDepartment,
      searchProcess,
      status,
    })

    dispatch({ type: actions.GET_EMP_LIST_IN_DOCS, payload: response?.data?.data })
  }
}
export const getEmpListInEmpMod = ({ locationId, isActive }) => {
  return async (dispatch) => {
    const response = await getListOfEmpInEmpMod({ locationId, isActive })

    dispatch({ type: actions.GET_EMP_LIST_IN_EMP, payload: response?.data?.data })
  }
}
